// extracted by mini-css-extract-plugin
export default {"container":"ScreenLayout_container__SIw4B","content":"ScreenLayout_content__7ZTWm","body":"ScreenLayout_body__t6r5c"};